<template>
  <div class="carrot">
      <div class="main-wrapper">
            <Menu></Menu>
            <pop-ebook-list :visible="popVisible" @close="popClose()" :bookname="ebookVo.ebookName"></pop-ebook-list>
            <div class="page-wrapper">
                <div class="page-content">
                    <div class="row">
                        <div class="col-xl-12">
                                <h3 class="page-title">교재 관리</h3>
                                <p class="lead">
                                    <span>- E-Book URL: 학습자용 이북 링크 (없을 경우 공란)</span><br>
                                    <span>- PDF: 학습자용 PDF교재 (학습자에게 노출됨)</span><br>
                                    <span>- 티칭가이드(강사용 PDF): 강사용 PDF 교재(학습자에게 노출되지 않음)</span><br>
                                    <span>- 교재 수정 시 현재 교재를 사용중인 학습자에게도 수정된 교재로 노출 됩니다</span><br>
                                    <span class="red">- 신규 등록 시 버전은 1.0으로 자동 설정 됩니다.</span>
                                </p>
                        </div>
                    </div>

                    <div class="row mt-20">
                        <div class="col-md-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <div class="clear text-center">
                                        <ValidationObserver ref="bookAdd">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>* 교재 명</th>
                                                        <td colspan="12" class="text-left">
                                                            <ValidationProvider   name="교재 명" rules="required" v-slot="{ errors }">
                                                                <input v-model="ebookVo.ebookName" type="text" class="fl form-control w-20" name="bookName">
                                                                <button  class="btn btn-primary ml-3" @click="checkEbookName()">중복확인</button>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                            
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>ISBN</th>
                                                        <td class="text-left">
                                                            <input type="text" class="fl form-control w-100" v-model.trim="ebookVo.ebookIsbn" name="bookName">
                                                        </td>

                                                        <th>
                                                            * 언어
                                                        </th>
                                                        <td class="text-left">
                                                            <ValidationProvider name="언어" rules="required" v-slot="{ errors }">
                                                                <input v-model="ebookVo.ebookLanguage" value="영어" name="en" type="radio">영어
                                                                <input v-model="ebookVo.ebookLanguage" value="중국어" name="cn" class="ml-3" type="radio">중국어
                                                                <input v-model="ebookVo.ebookLanguage" value="일본어" name="jp" class="ml-3" type="radio">일본어
                                                                <input v-model="ebookVo.ebookLanguage" value="스페인어" name="es" class="ml-3" type="radio">스페인어
                                                                <input v-model="ebookVo.ebookLanguage" value="기타 외국어" name="ot" class="ml-3" type="radio">기타 외국어
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>* 학습영역</th>
                                                        <td class="text-left">
                                                            <ValidationProvider name="학습영역" rules="required" v-slot="{ errors }">
                                                                <select class="form-control fl w-100" v-model="ebookVo.ebookStudyArea">
                                                                    <option value="">학습 영역 전체</option> 
                                                                    <option value="회화">회화</option>
                                                                    <option value="작문">작문</option>
                                                                    <option value="청취">청취</option>
                                                                    <option value="독해">독해</option>
                                                                    <option value="문법">문법</option>
                                                                    <option value="어휘">어휘</option>
                                                                    <option value="발음">발음</option>
                                                                </select>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>

                                                        <th>
                                                            * 레벨
                                                        </th>
                                                        <td class="text-left">
                                                            <ValidationProvider name="레벨" rules="required" v-slot="{ errors }">
                                                                <input name="초급" v-model="ebookVo.ebookLevel" value="초급" type="radio">초급
                                                                <input name="중급" v-model="ebookVo.ebookLevel" value="중급" type="radio" class="ml-3">중급
                                                                <input name="고급" v-model="ebookVo.ebookLevel" value="고급" type="radio" class="ml-3">고급
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            * 카테고리
                                                        </th>
                                                        <td colspan="12">
                                                            <div class="category">
                                                                <ValidationProvider name="카테고리" rules="required" v-slot="{ errors }">
                                                                    <div class="code-box" v-for="(item,index) in categoryList" :key="index">
                                                                        <input :id="item.categoryCode" :value="item.categoryCode"  v-model="codeEbookCategoryArray" type="checkbox">
                                                                        <label :for="item.categoryCode">{{ item.name }}</label>
                                                                    </div>
                                                                    <div class="text-left mt-3" v-if="errors[0]">
                                                                        <span class="text-left error">{{ errors[0] }}</span>
                                                                    </div>
                                                                </ValidationProvider>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            * 사용유무
                                                        </th>
                                                        <td  class="text-left">
                                                            <ValidationProvider name="사용유무" rules="required" v-slot="{ errors }">
                                                                <input name="use" v-model="ebookVo.ebookUseStatus" type="radio" value="사용">사용
                                                                <input name="notuse" v-model="ebookVo.ebookUseStatus" class="ml-3" type="radio" value="사용 안함">사용 안함
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>

                                                        <th>
                                                            * 노출 시스템
                                                        </th>
                                                        <td class="text-left">
                                                            <ValidationProvider name="노출 시스템" rules="required" v-slot="{ errors }">
                                                                <input name="all" v-model="ebookVo.ebookExposureSystem" value="공용" type="radio">공용
                                                                <input name="ctm" v-model="ebookVo.ebookExposureSystem" value="CTM" class="ml-3" type="radio">CTM
                                                                <input name="itm" v-model="ebookVo.ebookExposureSystem" value="ITM" class="ml-3" type="radio">ITM
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            PDF
                                                        </th>
                                                        <td class="text-left" colspan="12">
                                                            <ValidationProvider ref="pdfEbook" name="PDF" rules="extension:pdf|filesize:50" v-slot="{ errors,validate  }" >
                                                                <input type="file" name="pdfEbook" id="pdfEbook" @change="validate($event) && fileSelect($event)">
                                                                <span>* 50MB 이하 pdf 파일만 등록 가능합니다.</span>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error dp-block">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            E-book (프린트)
                                                        </th>
                                                        <td class="text-left" colspan="12">
                                                            <input  class="fl form-control w-50" name="ebookprint" v-model="ebookVo.ebookPrintUrl" type="text">
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            E-book (프린트불가)
                                                        </th>
                                                        <td class="text-left" colspan="12">
                                                            <input  class="fl form-control w-50" name="ebooknotprint" v-model="ebookVo.ebookNonPrintUrl" type="text">
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            Mp3
                                                        </th>
                                                        <td class="text-left"  colspan="12">
                                                            <ValidationProvider ref="mp3Ebook" name="Mp3" rules="extension:zip,mpeg|filesize:50" v-slot="{ errors,validate }"> <!-- size는 kb 기준이다 -->
                                                                <input type="file" name="mp3Ebook" id="mp3Ebook" @change="validate($event) && fileSelect($event)">
                                                                <span>* 50MB 이하 zip, mp3 파일만 등록 가능합니다.</span>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error dp-block">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                            
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>
                                                            썸네일
                                                        </th>
                                                        <td class="text-left" colspan="12">
                                                            <ValidationProvider ref="thumbnailEbook" name="썸네일" rules="ext:jpg,png|filesize:2" v-slot="{ errors,validate  }" >
                                                                <input type="file" name="thumbnailEbook" id="thumbnailEbook" @change="validate($event) && fileSelect($event)">
                                                                <span>* 2MB 이하 jpg, gif, png파일만 등록 가능합니다.</span>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error dp-block">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                            
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th class="text-capitalize">
                                                            Teacher Guide
                                                        </th>
                                                        <td class="text-left" colspan="12"  >
                                                            <ValidationProvider ref="guidePdfEbook" name="guidePdfEbook" rules="ext:pdf|filesize:50" v-slot="{ errors,validate  }">
                                                                <input type="file" name="guidePdfEbook" id="guidePdfEbook" @change="validate($event) && fileSelect($event)">
                                                                <span>* 50MB 이하 pdf 파일만 등록 가능합니다.</span>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error dp-block">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            강사용 PDF
                                                        </th>
                                                        <td class="text-left" colspan="12"  >
                                                            <ValidationProvider ref="lecturePdfEbook" name="lecturePdfEbook" rules="ext:pdf|filesize:50" v-slot="{ errors,validate  }">
                                                                <input type="file" name="lecturePdfEbook" id="lecturePdfEbook" @change="validate($event) && fileSelect($event)">
                                                                <span>* 50MB 이하 pdf 파일만 등록 가능합니다.</span>
                                                                <div class="text-left mt-3" v-if="errors[0]">
                                                                    <span class="text-left error dp-block">{{ errors[0] }}</span>
                                                                </div>
                                                            </ValidationProvider>
                                                        </td>
                                                    </tr>                                                    
                                                </thead>
                                            </table>
                                        </ValidationObserver>
                                        <button class="btn btn-primary fl mt-3" @click="back()">취소</button>
                                        <button class="btn btn-primary fr mt-3" @click="submit()" :disabled="loading">
                                            {{ loading ? '처리중...' : '등록' }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>  
  </div>
</template>

<script>
import Menu from '../../components/commons/incMenu';
import popEbookListVue from '../../components/popEbookList.vue';
export default {
    name: 'bookAdd',
    watch:{
        'ebookVo.ebookName':{
            handler(value, oldValue){
                if(value !== oldValue){
                    this.ebookVo['btnCheckd'] = false;
                }
            }
        }
    },
    data(){
        return{
            loading: false,
            popVisible: false,
            categoryList:[],
            codeEbookCategoryArray:[], // 카테고리 코드 배열
            ebookVo:{
                ebookName:'',//교재명
                ebookIsbn: '',
                btnCheckd:false, //중복확인
                ebookLanguage:'',//
                ebookStudyArea: '',//학습영역
                ebookLevel:'', //이북레벨
                codeEbookCategory: '',//이북카테고리
                ebookUseStatus: '', //이북 사용유무
                ebookExposureSystem: '',//노출시스템
                ebookPrintUrl: '',// 프린트가능ebook_url
                ebookNonPrintUrl:'', // 프린트불가ebook_url
            },
            formData: new FormData(),
            ebookList:[],
        }
    },
    components:{
        Menu,
        'pop-ebook-list':popEbookListVue
    },
    created(){
        this.selectCategories();
    },
    methods:{
        /**
         * @description : 카테고리 데이터 호출
         */
        selectCategories(){
            this.axios.get('/v1/api/admin/category')
                .then(res=>{
                    this.categoryList = res.data.categories;
                }).catch(err => {
                    if (err.response.data.path === '/login/msg') {
                        alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
                        this.$router.push('/login')
                    } else {
                        alert('관리자에게 문의하세요')
                    }
                })
        },

        /**
         * @description : 이북명 중복확인
         */
        checkEbookName(){
            //1. 빈값 체크
            if(!this.ebookVo.ebookName){
                //2. 값이 없으면 값이 필요하다는 alert
                alert('교재명을 입력해주세요');
                return false;
            }
            else if(this.ebookVo.ebookName.trim().length <= 1){
                //2. 값이 없으면 값이 필요하다는 alert
                alert('두 글자 이상 입력해주세요.');
                return false;
            }

            const params = {
                ebookName: this.ebookVo.ebookName
            }

            this.axios.get('/api/v1/ebook/dup',{
                params: params
            }).then((res)=>{
                const { ebookList, err } = res.data;
                if(err === 0){
                    this.ebookList = ebookList;
                    //3. 결과가 1개이상이면 팝업
                    this.popVisible = true;
                }else{
                    //4. 결과가 1개도 없으면 중복확인 해제 this.ebookVo['btnCheckd'] = true;
                    this.ebookVo['btnCheckd'] = true;
                    alert("사용가능한 교재명입니다.");
                }
            }).catch((err)=>{
                console.error('/api/v1/ebook/dup : ' , err);
                alert("중복확인을 할 수 없습니다.")
            })


        },  

        /**
         * @description Modal close
         */
        popClose(){
            this.popVisible = false;
        },

        /**
         * @description : submit
         */
        async submit(){
            if (this.loading) return; // 이미 로딩 중이면 중복 실행 방지
            
            try {
                this.loading = true; // 로딩 시작
                
                //1.전체 validation
                await this.$refs.bookAdd.validate();

                //2.필수값만 체크 
                const { $children } = await this.$refs.bookAdd;
                for(const child of $children){
                   if(child['flags']['required'] && !child['flags']['valid']){
                       alert('필수값 확인을 해주세요.');
                       return false;
                   }
                }

                //3.중복확인 체크 여부
                if(!this.ebookVo['btnCheckd']){
                    alert('교재명 중복확인을 해주세요.');
                    return false;
                }
                
                //4. array to string
                this.arrayToString(this.codeEbookCategoryArray);

                //5.query string 생성
                let str ='';
                for(const item in this.ebookVo){
                    str +=`${item}=${encodeURIComponent(this.ebookVo[item])}&`;
                }

                //6.formData 전송
                const res = await this.axios.post(`/api/v1/ebook?${str}`, this.formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                });

                const { err, result } = res.data;
                if(err === 0){
                    alert(result);
                    this.back();
                } else {
                    alert(result);
                }
            } catch (err) {
                alert('등록에 실패하였습니다.')
                console.error('/api/v1/ebook error : ',err);
            } finally {
                this.loading = false; // 로딩 종료
            }
        },

        /**
         * @description : 파일 변화
         */
        async fileSelect($event){
            //ebookVo에 key값 존재 여부 확인
            const { valid } = await this.$refs[$event.srcElement.id].validate();
              
            if(!valid){
                const fileEle = document.getElementById($event.srcElement.id);
                fileEle.value = '';
                this.formData.append('formData', '');
            }else{            
                this.formData.append($event.srcElement.id, document.getElementById($event.srcElement.id).files[0]);
            }
        },

        /**
         * @description back
         */
        back(){
            this.$router.back(-1);
        },

        /**
         * @description : array to string
         */
        arrayToString(obj){
            let str = '';
            if(Array.isArray(obj)){
                if(obj.length > 1){
                    obj.forEach((ele,index) => {
                        if(index === 0){
                            str+=ele;
                        }else{
                            str+=`, ${ele}`;
                        }
                    });
                }
                else if(obj.length === 1){
                    str=obj[0];
                }
                this.ebookVo.ebookCategory = str;
            }
        },
    }
}
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";

.category{
    width: 70%;
    text-align: left;
}
input[type="checkbox"]{
 margin-top: 5px;
}
.code-box{
    min-width: 30%;
    display: inline-block;
}

.error{
    color: red;
    display: block;
}
.text-capitalize {
    text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/pages/book/bookAdd.vue